// extracted by mini-css-extract-plugin
export var active = "_2w-2";
export var container = "_2w-0";
export var expired = "_2w-3";
export var hasStatus = "_2w-4";
export var statusChip = "_2w-1";